// NPM Imports
import React, { useContext } from 'react'
import toast from 'react-hot-toast'
// Quote Context
import { useQuoteContext } from '../../../hooks/useQuoteContext'
// Component Imports
import Description from '../../ui-helper-elements/Description'
// JS Imports
// Asset Imports

export default function MultiEINInputRow() {
   const state = useQuoteContext()
   const { getString, getFormattedString } = state
   const permissions = state.featurePermissions['MultiEIN']

   const activeEINCount = state.accountSnowflake?.EINs__c?.[0]?.length
   // Only enforce as a minimum when in difference quote mode — same pattern as CloneEinButton
   const minEINCount = state.differenceQuote ? activeEINCount : 0

   // Show warning toast with proper positioning
   const showEINWarningToast = (activeEINCount) => {
      toast(
         getFormattedString('product.MultiEINInputRow.Toast.Text', {
            accountName: state.account_name,
            activeEINCount: activeEINCount,
         }),
         {
            duration: 6000,
            icon: '⚠️',
            style: {
               maxWidth: '500px',
               width: '500px',
               zIndex: 9999,
            },
            // Use a consistent ID to avoid duplicate toasts
            className: 'eintoast',
            id: 'ein-warning-toast',
         },
      )
   }

   // Validate EIN count when committing a value (not during typing)
   const validateEINCount = (value) => {
      if (minEINCount && parseInt(value) < minEINCount) {
         showEINWarningToast(activeEINCount)
         return minEINCount
      }
      return value
   }

   // Handle onChange without immediate validation
   const handleEINCountChange = (value) => {
      // No validation during typing - just update the value
      state.onProductPayrollEINCountChange(value)
   }

   // Handle onBlur with validation
   const handleEINCountBlur = () => {
      const newValue = validateEINCount(state.productPayrollEINCount)
      state.onProductPayrollEINCountChange(Math.floor(newValue))
   }

   // Handle keypresses (for arrow keys and Enter)
   const handleKeyDown = (e) => {
      if (minEINCount) {
         if (
            e.key === 'ArrowDown' &&
            state.productPayrollEINCount <= minEINCount
         ) {
            e.preventDefault()
            showEINWarningToast(activeEINCount)
            return
         }

         // Validate on Enter key press
         if (e.key === 'Enter') {
            const newValue = validateEINCount(state.productPayrollEINCount)
            if (newValue !== state.productPayrollEINCount) {
               e.preventDefault()
               state.onProductPayrollEINCountChange(newValue)
            }
         }
      }
   }

   if (
      permissions.includes(state.user_role) ||
      state.productPayrollEINCount > 1
   )
      return (
         <div className='row'>
            <div className='col-bhr1'>
               {getString('product.MultiEINInputRow.ProductName')}
            </div>
            <div className='col-bhr2'>
               {state.payrollInfoRecords.length > 1 ? (
                  <Description
                     content={getString(
                        'product.MultiEINInputRow.Hover.Content',
                     )}
                     placement='top'
                     popoverClassName='warning-popover'
                  >
                     <input
                        className='form-control'
                        type='number'
                        value={
                           state.productPayrollEINCount <= 0
                              ? ''
                              : state.productPayrollEINCount.toString()
                        }
                        onChange={(e) =>
                           handleEINCountChange(Number(e.target.value))
                        }
                        onKeyDown={handleKeyDown}
                        onBlur={handleEINCountBlur}
                        min={minEINCount}
                        placeholder={'0'}
                        disabled
                     />
                  </Description>
               ) : (
                  <input
                     className='form-control'
                     type='number'
                     value={
                        state.productPayrollEINCount <= 0
                           ? ''
                           : state.productPayrollEINCount.toString()
                     }
                     onChange={(e) =>
                        handleEINCountChange(Number(e.target.value))
                     }
                     onKeyDown={handleKeyDown}
                     onBlur={handleEINCountBlur}
                     min={minEINCount}
                     placeholder={'0'}
                  />
               )}
            </div>
            <div className='col'>
               {activeEINCount > 0
                  ? state.differenceQuote
                     ? '(' +
                       activeEINCount +
                       (activeEINCount > 1 ? ' active EINs)' : ' active EIN)')
                     : '(plus ' +
                       activeEINCount +
                       (activeEINCount > 1
                          ? ' existing EINs)'
                          : ' existing EIN)')
                  : ''}
            </div>
            <div className='col'></div>
            <div className='col'></div>
            <div className='col'></div>
            {state.differenceQuote == true ? (
               <>
                  <div className='col col-bhr-blue'></div>
                  <div className='col'></div>
               </>
            ) : (
               <></>
            )}
         </div>
      )
}
